class VisuallyCartSubscription extends HTMLElement {
  constructor() {
    super()
    this.eventListenerName = this.dataset.eventListenerName
    this.productId = Number(this.dataset.productId) || false
    this.productPrice = this.dataset.productPrice || false
    this.currentSubscriptionId = this.dataset.subscriptionId || false
    this.quantity = this.dataset.quantity || 1
    this.id = this.dataset.id
    if (!this.eventListenerName || !this.productId || !this.id) return

    this.rendered = false
    this.subscriptionId = false
    this.store = window.theme.storefront.store
    this.apiToken = window.theme.storefront.apiToken
    this.handleDataEvent = this.handleDataEvent.bind(this)

    window.addEventListener(this.eventListenerName, this.handleDataEvent)
    if (window.VISUALLY_CART_SUBSCRIPTION_DATA?.length > 0) {

      window.VISUALLY_CART_SUBSCRIPTION_DATA.forEach((item) => {
        if (this.productId == item?.productId) {
          this.renderSection(item)
          this.rendered = true
          return false
        }
      })
    }
  }

  handleDataEvent(e) {
    console.log(' Event triggered by visually', e)
    e?.detail?.data.forEach((item) => {
      if (this.productId == item?.productId) {
        window.VISUALLY_CART_SUBSCRIPTION_DATA = e.detail.data
        this.renderSection(item)
        this.rendered = true
        return false
      }
    })
    window.removeEventListener(this.eventListenerName, this.handleDataEvent)
  }

  updateSubscription(button) {
    if (!this.id || this.classList.contains('is-loading')) {
      console.error('Missing ID');
      return;
    }

    button.classList.add('is-loading')
    // // Remove the existing line item
    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        id: this.id,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(() => {
      // Add the new product with the selling plan
      const data = {
        id: this.id,
        quantity: this.quantity
      }

      if (button.classList.contains('is-subscription')) {
        data.selling_plan = this.subscriptionId
      }

      const body = JSON.stringify({
        ...data,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          }));
        })
        .catch((e) => {
          console.error(e);
        })
      })
    .finally(() => {
      this.classList.remove('is-loading')
    })
  }

  renderSection(data) {
    if (!data || this.rendered) return

    this.innerHTML = ''

    const { radioMode = false, title, bullets, button, productId, subscriptionId, price, compareAtPrice = false, oneTimeTitle = false } = data
    if (productId !== this.productId) return
    this.subscriptionId = subscriptionId

    const html = 
      radioMode
        ? this.htmlOutputRadio(title, bullets, price, compareAtPrice, oneTimeTitle)
        : this.currentSubscriptionId
          ? ''
          : this.htmlOutputButton(title, bullets, button, price, compareAtPrice)

    this.innerHTML = html

    radioMode
      ? this.htmlRadioListeners()
      : this.htmlButtonListeners()
  }

  htmlRadioListeners() {
    const buttons = this.querySelectorAll('.cart-drawer__item__upgrade__header.is-button')
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const isButtonSubscription = button.classList.contains('is-subscription')

        if (isButtonSubscription === this.currentSubscriptionId) {
          console.log('Nothing to do!')
          return
        }

        this.updateSubscription(button)
      })
    })
  }

  htmlOutputRadio(title, bullets, price, compareAtPrice, oneTimeTitle) {
    if (this.currentSubscriptionId) { return '' }

    return  `
      <div class="cart-drawer__item__upgrade">
        <button type="button" class="cart-drawer__item__upgrade__header is-button">
          <span class="cart-drawer__item__upgrade__header__icon">
            ${this.getRadioIcon(!this.currentSubscriptionId)}
          </span>
          <p class="cart-drawer__item__upgrade__title">${oneTimeTitle || 'One-Time Purchase'}</p>
          <p class="cart-drawer__item__upgrade__price">
            <span>${compareAtPrice ? compareAtPrice : this.productPrice}</span>
          </p>
        </button>
      </div>
      <div class="cart-drawer__item__upgrade --has-additional-margin">
        <button type="button" class="cart-drawer__item__upgrade__header is-button is-subscription">
          <span class="cart-drawer__item__upgrade__header__icon">
            ${this.getRadioIcon(this.currentSubscriptionId)}
          </span>
          <p class="cart-drawer__item__upgrade__title">${title}</p>
          <p class="cart-drawer__item__upgrade__price">
            <span class="grey-out">${compareAtPrice ? compareAtPrice : this.productPrice}</span>
            <span>${price}</span>
          </p>
        </button>
        <ul class="cart-drawer__item__upgrade__list">
          ${bullets.map(item => `<li>${item}</li>`).join('')}
        </ul>
      </div>
    `
  }

  htmlButtonListeners() {
    const ctaButton = this.querySelector('.cart-drawer__item__upgrade__cta')
    ctaButton.addEventListener('click', () => {
      this.updateSubscription(ctaButton)
    })
  }

  htmlOutputButton(title, bullets, button, price, compareAtPrice) {
    return  `
      <div class="cart-drawer__item__upgrade">
        <div class="cart-drawer__item__upgrade__header">
          <p class="cart-drawer__item__upgrade__title">${title}</p>
          <p class="cart-drawer__item__upgrade__price">
            <span class="grey-out">${compareAtPrice ? compareAtPrice : this.productPrice}</span>
            <span>${price}</span>
          </p>
        </div>
        <ul class="cart-drawer__item__upgrade__list">
          ${bullets.map(item => `<li>${item}</li>`).join('')}
        </ul>
        ${
          button.redirect_url
            ? `<a href="${button.redirect_url}" class="cart-drawer__item__upgrade__cta button">${button.text}</a>`
            : `<button type="button" class="cart-drawer__item__upgrade__cta button is-subscription">${button.text}</button>`
        }
      </div>
    `
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-drawer__header',
        section: document.getElementById('cart-drawer__header').dataset.id,
        selector: '.cart-drawer__header',
      },
      {
        id: 'cart-drawer__footer',
        section: document.getElementById('cart-drawer__footer').dataset.id,
        selector: '.cart-drawer__footer',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    console.log(' getSectionInnerHTML:', selector)
    console.log(html)
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  getRadioIcon(isActive) {
    return isActive
      ? `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 20C15.5229 20 20 15.5229 20 10C20 4.47713 15.5229 0 10 0C4.47713 0 0 4.47713 0 10C0 15.5229 4.47713 20 10 20Z" fill="black"/>
          <path d="M5.8335 10.8333L8.3335 13.3333L14.1668 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`
      : `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1C14.9706 1 19 5.02942 19 10C19 14.9706 14.9706 19 10 19C5.02942 19 1 14.9706 1 10C1 5.02942 5.02942 1 10 1Z" stroke="black" stroke-width="2"/>
        </svg>`
  }
}

customElements.define('visually-cart-subscription', VisuallyCartSubscription)
